import React from "react";
import PropTypes from 'prop-types';

var ToRead = function ToRead(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 10 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 10 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#D82525' : _ref$color;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "5",
    fill: color
  }));
};

ToRead.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string
};
export default ToRead;